module.exports = __webpack_public_path__ + "static/alternates-ddd8955eb31c6a428e2ce95cababf61a.png";